<template>
  <div v-if="problem" class="login column align-center justify-center">
    <div class="container column align-center">
      <i class="fa fa-exclamation-triangle"></i>
      Ops... houve algum erro com os dados de login
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",

  data() {
    return {
      dados: {
        login: "",
        senha: "",
      },

      problem: false,
    };
  },
  methods: {
    ...mapActions("user", ["GET_SESSION"]),
    login(data) {
      this.GET_SESSION(data)
        .then((e) => {
          if (e.response.status == 401) this.problem = true;
        })
        .catch((e) => {
          if (e.response.status == 401) this.problem = true;
        });
    },
  },
  beforeMount() {
    let url = window.location.toString();
    let cred = url.toString().split("?")[1];

    //LOGIN WHITE LABEL
    if (
      cred &&
      url.indexOf("token=") > 0 &&
      url.indexOf("cliente=") > 0 &&
      (url.indexOf("email=") > 0 || url.indexOf("id_usuario=") > 0)
    ) {
        const token = cred.split("&")[1].split("=")[1];
        const client = cred.split("&")[2].split("=")[1];
        let payload = url.indexOf("email=") > 0
          ? {
              email: cred.split("&")[0].split("=")[1].replace("%40", "@"),
              token: token,
              client: client,
            }
          : {
              id: cred.split("&")[0].split("=")[1].replace("%40", "@"),
              token: token,
              client: client,
            };
          this.login(payload);
    } else {
      this.problem = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.login {
  height: 100vh;
  .container {
    background: #fff;
    box-shadow: $shadow;
    border-radius: 7px;
    padding: 25px 50px;
    font-weight: bold;
    color: $gray-6;
    i {
      font-size: 50px;
      margin-bottom: 15px;
    }
  }
}
</style>
